import React, { useState } from 'react';
import { Svg } from 'src/components/Svg/Svg';
import classnames from 'classnames';

import classes from './DynamicExpandCollapseWrapper.scss';

type Props = {
    itemsAmountExpanded: number;
};

const NUMBER_OF_COINS_IN_THE_POCKET = 10;

export const DynamicExpandCollapseWrapper: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    itemsAmountExpanded,
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const isCollapsingComponent = itemsAmountExpanded > NUMBER_OF_COINS_IN_THE_POCKET;

    return (
        <div
            className={classnames(classes.expandCollapseWrapper, {
                [classes.expanded]: isExpanded,
                [classes.collapsingComponent]: isCollapsingComponent,
            })}
        >
            {children}
            {isCollapsingComponent && (
                <div className={classnames(classes.expandCollapseButton, { [classes.expanded]: isExpanded })}>
                    <div
                        className={classnames(classes.expandCollapseIcon, { [classes.expanded]: isExpanded })}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        <Svg name="arrow-down" />
                    </div>
                </div>
            )}
        </div>
    );
};
